import { Controller } from 'stimulus';

import universalTracking from '../tracking/universalTracking';
import delegatedEventListener from '../helpers/delegatedEventListener';

class Tracking extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    Tracking.trackTiming();
    Tracking.trackLinks();
  }

  static trackLinks() {
    delegatedEventListener('click', 'a', document, ({ target }) => {
      if (target.matches('a[href^="tel:"]')) {
        const location = target.getAttribute('data-phone-location');

        universalTracking.event('Phone', 'click', location);

        return;
      }

      if (target.matches('a[href^="mailto:"]')) {
        const location = target.getAttribute('data-email-location');

        universalTracking.event('Mail', 'click', location);

        return;
      }

      if (target.matches('a[href*="instagram.com"]')) {
        universalTracking.event('Instagram', 'click', target.href);

        return;
      }

      if (target.matches('a[href*="facebook.com"]')) {
        universalTracking.event('Facebook', 'click', target.href);

        return;
      }

      if (
        target.href.indexOf(window.location.host) <= 0
        && target.href.match(/^http/i)
      ) {
        universalTracking.event('Outbound', 'click', target.href);
      }
    });

    delegatedEventListener('submit', 'form', document, ({ target }) => {
      if (target.action.indexOf('.list-manage.com') >= 0) {
        universalTracking.event('Newsletter', 'submit');
      }
    });
  }

  static trackTiming() {
    if (!('performance' in window) || !('PerformanceObserver' in window)) {
      return;
    }

    const observer = new PerformanceObserver(this.measureTiming);
    observer.observe({ entryTypes: ['navigation'] });
  }

  static measureTiming(list) {
    const entries = list.getEntries();

    entries.forEach((entry) => {
      universalTracking.timing('ttfb', entry.responseStart - entry.requestStart);
      universalTracking.timing('domInteractive', entry.domInteractive - entry.requestStart);
    });
  }
}

Tracking.targets = [
  //
];

export default Tracking;
